import React, { useState } from 'react';
import hicon from '../../images/icon/magic.svg';
import Header2 from '../Header2/Header2';
import { Fade } from 'react-awesome-reveal';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from 'reactstrap';
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
  Divider,
  CardMedia,
  Button,
} from '@mui/material';
import Footer from '../footer/Footer';

const FaqSection = () => {
  const [open, setOpen] = useState('1');
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <>
      <Header2 Faq="FAQ" />
      <main>
        <Box sx={{ mt: 10, p: 3 }}>
          <section className="faq pb-140 mt-5">
            <div className="container ">
              <div className="sec-title--two text-center mb-60">
                <Fade
                  direction="up"
                  triggerOnce={true}
                  duration={1200}
                  delay={9}
                >
                  <div>
                    <h2
                      className="title wow fadeInDown"
                      data-wow-delay="150ms"
                      data-wow-duration="600ms"
                    >
                      FAQ
                    </h2>
                    <p className="mt-4">Got a Question? We’ve Got Answers!</p>
                  </div>
                </Fade>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div
                    className="xb-faq wow fadeInUp"
                    data-wow-delay="200ms"
                    data-wow-duration="600ms"
                  >
                    <Accordion
                      open={open}
                      toggle={toggle}
                      className="accordion_box clearfix list-unstyled"
                    >
                      <AccordionItem className="block">
                        <AccordionHeader targetId="1" className="acc-btn">
                          <span
                            className="number"
                            style={{ marginRight: '15px' }}
                          >
                            01
                          </span>
                          What size dumpster do I need?
                          <span className="arrow"></span>
                        </AccordionHeader>
                        <AccordionBody accordionId="1" className="acc_body">
                          <div className="content">
                            <p>
                              We offer various dumpster sizes, ranging from
                              10-yard to 40-yard containers. The size you need
                              depends on the type and volume of waste you’re
                              disposing of.
                            </p>
                          </div>
                        </AccordionBody>
                      </AccordionItem>
                      <AccordionItem className="block">
                        <AccordionHeader targetId="2" className="acc-btn">
                          <span
                            className="number"
                            style={{ marginRight: '15px' }}
                          >
                            02
                          </span>{' '}
                          How long can I keep the dumpster?
                          <span className="arrow"></span>
                        </AccordionHeader>
                        <AccordionBody accordionId="2" className="acc_body">
                          <div className="content">
                            <p>
                              Our standard rental period is 7 days, but we offer
                              flexible rental terms to suit your project needs.
                              Additional fees may apply for extended rentals.
                            </p>
                          </div>
                        </AccordionBody>
                      </AccordionItem>
                      <AccordionItem className="block">
                        <AccordionHeader targetId="3" className="acc-btn">
                          <span
                            className="number"
                            style={{ marginRight: '15px' }}
                          >
                            03
                          </span>{' '}
                          What items can I dispose of in the dumpster?
                          <span className="arrow"></span>
                        </AccordionHeader>
                        <AccordionBody accordionId="3" className="acc_body">
                          <div className="content">
                            <p>
                              Common items include household debris,
                              construction waste, furniture, and yard waste.
                              Hazardous materials such as chemicals, batteries,
                              and tires are prohibited.
                            </p>
                          </div>
                        </AccordionBody>
                      </AccordionItem>
                      <AccordionItem className="block">
                        <AccordionHeader targetId="4" className="acc-btn">
                          <span
                            className="number"
                            style={{ marginRight: '15px' }}
                          >
                            04
                          </span>{' '}
                          Do I need a permit to rent a dumpster?
                          <span className="arrow"></span>
                        </AccordionHeader>
                        <AccordionBody accordionId="4" className="acc_body">
                          <div className="content">
                            <p>
                              If you’re placing the dumpster on private
                              property, no permit is needed. However, if it will
                              be placed on a public street, you may need a
                              permit from your local municipality.
                            </p>
                          </div>
                        </AccordionBody>
                      </AccordionItem>
                      <AccordionItem className="block">
                        <AccordionHeader targetId="5" className="acc-btn">
                          <span
                            className="number"
                            style={{ marginRight: '15px' }}
                          >
                            05
                          </span>
                          How much does dumpster rental cost?
                          <span className="arrow"></span>
                        </AccordionHeader>
                        <AccordionBody accordionId="5" className="acc_body">
                          <div className="content">
                            <p>
                              Pricing varies based on the dumpster size, rental
                              duration, and location. Contact us for a
                              customized quote tailored to your needs.
                            </p>
                          </div>
                        </AccordionBody>
                      </AccordionItem>
                    </Accordion>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Box>
      </main>
      <Footer />
    </>
  );
};

export default FaqSection;
